import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { getUVEState } from '@dotcms/uve';

/**
 * The page header for error pages - the logo link reloads the app
 */
@Component({
  selector: 'ish-header-error',
  templateUrl: './header-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderErrorComponent implements OnInit {
  constructor(@Inject(APP_BASE_HREF) private baseHref: string) {}
  isInsideUveEditor = !!getUVEState();

  homeHref: string;

  ngOnInit() {
    this.homeHref = this.baseHref && this.baseHref !== '/' ? `${this.baseHref}/home` : '/home';
  }
}
